export function Footer() {
    function scrollToTop(){
        window.scrollTo({top: 0, behavior: 'smooth'});
    }
return(
    <footer className="u-bg-color--grey-dark gov-footer footer-padding">
        <div className="gov-container__content">
            <section className="gov-footer__upper">
                <div className="gov-footer__col gov-footer__col--logo">
                    <ul className="gov-list--plain">
                        <li>
                            <a href="https://sfpi.cz" target="_blank" rel="noreferrer">
                                <img src="/assets/footer_logo.svg" alt="SFPI" width="176" height="50" />
                            </a>
                        </li>
                    </ul>
                </div>
                <div className="gov-footer__col">
                    <h3 className="gov-footer__headline">Informace</h3>
                    <ul className="gov-list--plain">
                        <li>
                            <a href="https://sfpi.cz/pro-media/" className="gov-link  gov-link--standalone  gov-link--inversed">KONTAKTY PRO MÉDIA</a>
                        </li>
                        <li>
                            <a href="https://sfpi.cz/zpracovani-osobnich-udaju/" className="gov-link  gov-link--standalone  gov-link--inversed">ZPRACOVÁNÍ OSOBNÍCH ÚDAJŮ</a>
                        </li>
                    </ul>
                </div>
                <div className="gov-footer__col">
                    <h3 className="gov-footer__headline">
                        Kontakty
                    </h3>

                    <ul className="gov-list--plain">
                        <li className="u-color--white">
                            <a href="mailto:komunikace@sfpi.cz" className="gov-link gov-link--standalone gov-link--inversed">
                                <span className="gov-icon gov-icon--mail"></span> komunikace@sfpi.cz</a></li>
                        {/*<li className="u-color--white">*/}
                        {/*    <a href="tel:+420605072069" className="gov-link gov-link--standalone gov-link--inversed">*/}
                        {/*        <span className="gov-icon gov-icon--phone"></span> +420 605 072 069</a>*/}
                        {/*</li>*/}
                    </ul>
                </div>
                <div className="gov-footer__col">
                    <h3 className="gov-footer__headline">
                        Sledujte SFPI
                    </h3>

                    <ul className="gov-list--plain gov-list--inline">
                        <li>
                            <a href="https://www.facebook.com/sfpi.cz" className="gov-link--inversed">
                                <span className="gov-icon gov-icon--facebook"></span>
                            </a>
                        </li>
                        <li><a href="https://www.instagram.com/sfpi.cz/?hl=cs" className="gov-link--inversed">
                            <span className="sfpi-icon sfpi-icon--instagram sfpi-icon--no_margin"></span>
                        </a>
                        </li>
                        <li>
                            <a href="https://www.youtube.com/channel/UCUCpVo8pJ4soLcXCfmpPF0w" className="gov-link--inversed">
                                <span className="gov-icon gov-icon--youtube"></span>
                            </a>
                        </li>
                    </ul>
                </div>


                <button id="fo-scrollBtn" onClick={scrollToTop} className="gov-button gov-button--primary-outlined gov-button--inversed gov-footer__scroll-up gov-js--scroll-up" aria-labelledby="fo-scrollBtn">

            <span  className="u-sr-only gov-button__label">
                Zpět nahoru
            </span>
                </button>

            </section>
            <hr />
                <section className="gov-footer__lower">
                    <p className="gov-footnote">
                        {new Date().getFullYear()} © Státní fond podpory investic
                    </p>

                </section>
        </div>
    </footer>)
}


